import React from "react"


class PaymentInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            }
    }

    render() {
        return (
           <section>

            </section>
        )
    }

}

export default PaymentInfo


// WEBPACK FOOTER //
// ./src/Setup/modules/account/views/AccountInfo.js